module.exports = __webpack_public_path__ + "img/phrase_rounded.add2247.svg";